import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';

export function PortalLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = (response: CredentialResponse) => {
    if (response.credential) {
      login(response.credential);
      navigate('/portal');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Inter', system-ui, sans-serif",
        padding: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '420px',
          width: '100%',
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '20px',
          padding: '48px 40px',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.06)',
        }}
      >
        {/* Logo */}
        <div
          style={{
            width: '72px',
            height: '72px',
            margin: '0 auto 28px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #4338ca, #6366f1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '32px',
            boxShadow: '0 4px 12px rgba(67, 56, 202, 0.25)',
          }}
        >
          ⚡
        </div>

        <h1
          style={{
            color: '#0f172a',
            fontSize: '26px',
            fontWeight: 700,
            margin: '0 0 8px',
          }}
        >
          Quick Draw Funding
        </h1>
        <p
          style={{
            color: '#64748b',
            fontSize: '15px',
            margin: '0 0 36px',
            lineHeight: '1.6',
          }}
        >
          Sign in with your Google Workspace account to access the operations portal.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => {}}
            theme="outline"
            size="large"
            shape="rectangular"
            text="signin_with"
          />
        </div>
      </div>
    </div>
  );
}
